module.exports = __webpack_public_path__ + "media/images/ic-index-block-f60cea17d9412d55239f6c2e205108cb.svg";